import "@tailwindplus/elements";
import Alpine from "alpinejs";

import initAddToCart from "./components/addToCart";
import initAssortimentMenu from "./components/assortimentMenu";
import initBanner from "./components/banner";
import initCustomerSwitch from "./components/customerSwitch";
import "./components/forms";
import "./components/formValidation";
import initNavigation from "./components/navigation";
import initSliders from "./components/sliders";
import initBrandsOverview from "./components/brandsOverview";
import "./plugins/Craft";
import "./plugins/headroom";

window.Alpine = Alpine;

document.addEventListener("alpine:init", () => {
  initAddToCart();
  initAssortimentMenu();
  initBanner();
  initCustomerSwitch();
  initSliders();
  initNavigation();
  initBrandsOverview();
});

Alpine.start();

const priceMode =
  localStorage.getItem("Verwimp.catalog.price-mode") ?? "customer";
document.body.classList.add(`${priceMode}-price-mode`);

if (import.meta.hot) {
  import.meta.hot.accept(() => {
    // eslint-disable-next-line no-console
    console.log("HMR");
  });
}
